/**
 * The project id of a link that points at a project (`['/projects', id]` or `/projects/id`, the
 * Projects view's deep link), or null for any other link (`/projects` lists, Inbox, create
 * forms…), which keep navigating as before.
 */
export function projectIdOfLink(link: unknown): string | null {
  const parts = Array.isArray(link)
    ? link.map(String)
    : typeof link === 'string' ? link.split('/').filter(Boolean).map((p, i) => (i === 0 ? '/' + p : p)) : [];
  return parts.length === 2 && parts[0] === '/projects' && parts[1] ? parts[1] : null;
}

/**
 * A plain left click (no modifier, main button): the one that opens a side panel. Cmd/Ctrl/Shift-
 * click and the middle button keep the browser's own behaviour on the link's address (a new tab).
 */
export function isPlainClick(event: MouseEvent): boolean {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}
